import { CookieCategory } from '../types';
import { useCookieConsent } from './useCookieConsent';

/** True se la categoria è stata concessa. Reattivo alle variazioni di consenso. */
export function useConsent(category: CookieCategory): boolean {
  const { isCategoryGranted } = useCookieConsent();
  return isCategoryGranted(category);
}
